/* React/TypeScript/Vite entry. Domain rules remain in FastAPI. */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { LoginGate } from './app/LoginGate';
import './styles.css';
import './proposal-defaults.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Elemento raiz não encontrado');
createRoot(rootElement).render(<LoginGate />);